import React from "react";
import { Hotspot, Popup, Scene, TourData } from "../../../Types";
import {
  useCurrentSceneStore,
  useEditingElementStore,
} from "../../../api/Zustand";

import * as THREE from "three";
import { useCameraPositionStore } from "../../../state management/zustand/gl-stores";
import { getLanguageFile } from "../../common/GetLanguageFile";

const OtherHotspots = (props: {
  type: "link" | "transition" | "popup" | "quiz" | "audio";
  currentHotspot: Hotspot;
  icon: JSX.Element;
  tourData: TourData;
  disabled?: boolean;
}) => {
  const { currentSceneID } = useCurrentSceneStore();

  const { setEditingElem } = useEditingElementStore();

  const camera = useCameraPositionStore();

  const { disabled, currentHotspot, tourData, type, icon } = props;

  const theresOtherSpots = React.useMemo(() => {
    return !!tourData?.scenes
      .find((one) => one.id === currentSceneID)!
      .hotspots.find(
        (link) => link.type === type && link.id !== currentHotspot?.id
      );
  }, [currentHotspot?.id, currentSceneID, type, tourData.scenes]);

  const displayedTitle = React.useMemo(() => {
    switch (props.type) {
      case "audio":
        return getLanguageFile("right_panel.other_audio");
      case "link":
        return getLanguageFile("right_panel.other_link");
      case "transition":
        return getLanguageFile("right_panel.other_waypoint");
      case "popup":
        return getLanguageFile("right_panel.other_pop");
      case "quiz":
        return getLanguageFile("right_panel.other_question");
    }
  }, [props.type]);

  if (theresOtherSpots)
    return (
      <>
        {theresOtherSpots ? (
          <>
            <h4>{displayedTitle}</h4>
            <div
              style={{
                overflowY: "auto",
                opacity: currentHotspot?.EDIT_POS ? ".5" : "1",
                pointerEvents: currentHotspot?.EDIT_POS ? "none" : "auto",
              }}
            >
              <div>
                {tourData!.scenes
                  .find((one) => one.id === currentSceneID)!
                  .hotspots.filter(
                    (link) =>
                      link.type === type && link.id !== currentHotspot?.id
                  )
                  .map((link, index) => (
                    <div
                      key={link.id}
                      style={{
                        alignItems: "center",
                        lineHeight: "2em",
                        background: alternatingBackgrounds[index % 2],
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (
                          currentHotspot?.EDIT_POS ||
                          currentHotspot?.isNew ||
                          disabled
                        ) {
                          return;
                        } else {
                          const dir = new THREE.Vector3(link.x, link.y, link.z);

                          camera.setCameraLookAt(dir.multiplyScalar(-1));

                          setEditingElem(type, link.id);
                        }
                      }}
                    >
                      <div
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <span
                          style={{
                            userSelect: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: ".2rem",
                          }}
                        >
                          {icon}
                          <i>{innerText(link, tourData)} </i>
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </>
        ) : (
          getLanguageFile("right_panel.no_other_spot")
        )}
      </>
    );
};

const innerText = (hs: Hotspot, tourData: TourData) => {
  if (hs.type === "transition")
    return (
      tourData?.scenes.find((one: Scene) => one.id === hs.target)?.title ??
      "Errore caricamento nome scena"
    );
  else if (hs.type === "quiz") {
    const thisQuestion = tourData.quizData?.data.find(
      (one) => one.questionId === hs.target
    );

    return thisQuestion?.questionText;
  } else if (hs.type === "popup")
    return tourData?.popups.find((one: Popup) => one.id === hs.target)?.title;

  return hs.title;
};

export default OtherHotspots;

const alternatingBackgrounds = ["#fff3", "#fff1"];
